var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAposthoptheIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 40,
    viewBox: "0 0 52 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8951 40C8.4673 40 5.68801 38.7302 3.55722 36.1905C1.51907 33.5531 0.5 30.1343 0.5 25.9341C0.5 20.464 2.02861 15.3846 5.08583 10.696C8.14305 5.90964 11.9414 2.34432 16.4809 0L17.3147 1.75824C15.3692 3.32112 13.6553 5.32356 12.173 7.76556C10.6907 10.2076 9.62534 13.2356 8.97684 16.8498L11.8951 17.5824C15.1376 18.3639 17.639 19.8291 19.3992 21.978C21.252 24.0293 22.1785 26.5201 22.1785 29.4505C22.1785 32.5763 21.1594 35.116 19.1213 37.0696C17.1757 39.0232 14.767 40 11.8951 40ZM41.2166 40C37.7888 40 35.0095 38.7302 32.8787 36.1905C30.8406 33.5531 29.8215 30.1343 29.8215 25.9341C29.8215 20.464 31.3501 15.3846 34.4074 10.696C37.4646 5.90964 41.2629 2.34432 45.8025 0L46.6362 1.75824C44.6907 3.32112 42.9768 5.32356 41.4946 7.76556C40.0123 10.2076 38.9469 13.2356 38.2984 16.8498L41.2166 17.5824C44.4591 18.3639 46.9605 19.8291 48.7207 21.978C50.5736 24.0293 51.5 26.5201 51.5 29.4505C51.5 32.5763 50.4809 35.116 48.4428 37.0696C46.4973 39.0232 44.0886 40 41.2166 40Z",
    fill: "#3B4CA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAposthoptheIcon);
export default __webpack_public_path__ + "static/media/aposthopthe_icon.f28b95ee29bfa123d31b1a7f957b5a5d.svg";
export { ForwardRef as ReactComponent };